import { globalApi as api } from '../../api';

export const fetchHolidaysData = async (year) => {

  try {
    const response = await api.get(`/get_holidays`, {
      params: {
        current_year: year
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updateHolidays = async (id, holidaysData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_holidays/${id}`, holidaysData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const deleteHolidays = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_holidays/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const HolidaysUpload = async (holidaysDataInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const response = await api.post('/upload_holidays', holidaysDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       }
//     });
//     return {
//       data: response,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response.data.error;
//   }
// };


export const HolidaysUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_holidays', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};

export const multiDeleteHolidays = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_holidays', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
